import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Sidebar from "./SideBar";
import { CarrierSideBar } from "./CarrierSideBar";
import { RectangleStackIcon } from "@heroicons/react/24/solid";
const CarrierReport = () => {
  return (
    <div className="p-4  min-h-fit">
      <div>
        <div className="pl-4 flex gap-2 items-center">
          <div>
            <RectangleStackIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
          </div>
          <div className="flex flex-col leading tight">
            <h3 className="text-xs font-medium text-gray-500">
              Reports Module
            </h3>
            <h1 className="mr-auto font-bold text-primary text-md uppercase">
              ALL CARRIER REPORTS
            </h1>
          </div>
        </div>
      </div>
      <div className="bg-white flex flex-row h-full ">
        <Router>
          <div
            className="w-1/5 h-full flex sm:w-auto overflow-y-auto flex-col flex-grow
             ml-4 bg-white mt-4 -mr-px z-10"
          >
            <Sidebar />
          </div>

          <div
            className={"w-4/5 bg-white table-shadow overflow-y-auto  mt-4 mr-4"}
          >
            {CarrierSideBar.map((main) => {
              return (
                <Switch key={main.title}>
                  <Route path={main.to} exact component={main.component} />
                </Switch>
              );
            })}
          </div>
        </Router>
      </div>
    </div>
  );
};
export default CarrierReport;
